import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {RecommendationComponent} from './recommendation/recommendation.component';


const routes: Routes = [
  {
    path: ':carddeckid',
    component: RecommendationComponent,
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DesignRecommenderRoutingModule { }
